import CreateQiniuCallbackGQL from '@/lib/api/graphql/CreateQiniuCallback.graphql'
import CreateQiniuPresignedTokenGQL from '@/lib/api/graphql/CreateQiniuPresignedToken.graphql'
import apolloClient from './apolloClient'

import {
  CreateQiniuCallbackMutation,
  CreateQiniuCallbackMutationVariables,
  CreateQiniuPresignedTokenMutation,
  CreateQiniuPresignedTokenMutationVariables,
} from '@/typings/domain'

export const createQiniuPresignedToken = async (input: CreateQiniuPresignedTokenMutationVariables['input']) => {
  return apolloClient.mutate<CreateQiniuPresignedTokenMutation, CreateQiniuPresignedTokenMutationVariables>({
    mutation: CreateQiniuPresignedTokenGQL,
    variables: { input },
  })
}

export const createQiniuCallback = async (input: CreateQiniuCallbackMutationVariables['input']) => {
  return apolloClient.mutate<CreateQiniuCallbackMutation, CreateQiniuCallbackMutationVariables>({
    mutation: CreateQiniuCallbackGQL,
    variables: { input },
  })
}
